const HtmlData = ({ data }) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: data }} className="paragraphs" />
    </>
  );
};

export default HtmlData;
